import { Input } from "@/components/ui/input";
import { boolToString } from "../../DesignUploadStep.functions";

export type DesignTableCellValue = string | number | boolean | null | undefined;

export interface DesignToggleFieldProps {
  value: DesignTableCellValue;
  isEditing: boolean;
  inputClassName?: string;
}

export const DesignToggleField = ({
  value,
  isEditing,
  inputClassName = "h-8 min-w-[120px]",
}: DesignToggleFieldProps) => {
  if (isEditing) {
    if (typeof value === "boolean") {
      return <input type="checkbox" checked={value} readOnly className="h-4 w-4 accent-primary" />;
    }

    return <Input value={String(value ?? "")} className={inputClassName} readOnly />;
  }

  if (typeof value === "boolean") {
    return boolToString(value);
  }

  return value ?? "—";
};
